module.exports = __webpack_public_path__ + "static/media/21ECLAC35.31f1de02.jpg";